import React from 'react';
import { ZapIcon, LeafIcon, HeartPulseIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="w-full bg-stone-50 py-16 md:py-20" data-id="element-546">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-548">
          How It Works
        </h2>

        <div className="grid md:grid-cols-3 gap-10 md:gap-8" data-id="element-549">
          {/* Step 1 */}
          <div className="text-center" data-id="element-550">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-551">
              <ZapIcon className="w-7 h-7 text-emerald-700" data-id="element-552" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-553">
              Step 1
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-554">
              Instant Access
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-555">
              After purchase, you'll immediately receive the Natural Remedy
              Survival Guide and both bonus guides as downloadable PDFs.
            </p>
          </div>

          {/* Step 2 */}
          <div className="text-center" data-id="element-556">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-557">
              <LeafIcon className="w-7 h-7 text-emerald-700" data-id="element-558" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-559">
              Step 2
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-560">
              Start With Common Remedies
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-561">
              Learn how to prepare simple natural remedies using ingredients you
              likely already have in your kitchen or can easily find at any
              grocery store.
            </p>
          </div>

          {/* Step 3 */}
          <div className="text-center" data-id="element-562">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-563">
              <HeartPulseIcon className="w-7 h-7 text-emerald-700" data-id="element-564" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-565">
              Step 3
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-566">
              Support Your Body Naturally
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-567">
              Use the guide as your everyday reference for immunity, digestion,
              sleep, inflammation, and natural first aid.
            </p>
          </div>
        </div>
      </div>
    </section>;
}